import React from 'react';
import PropTypes from 'prop-types';

import { SETTINGS_PERMISSIONS, PERMISSIONS } from 'contexts/PermissionsContext';
import { setCookie } from 'utils/cookies';
import { DEMO_MODE_COOKIE_NAME, isDemoMode } from 'utils/apiRequests';

import { Subnav, SubnavLink, SubnavExternalLink } from '../Subnav';

class SettingsSubnav extends React.Component {
	static propTypes = {
		disabled: PropTypes.bool,
	};

	static defaultProps = {
		disabled: false,
	};

	state = {
		subnavOpen: false,
	};

	render() {
		const { subnavOpen } = this.state;
		const { permissions, noData, forceSettings } = this.props;
		const { REACT_APP_DATA_FACTORY_URL } = process.env;
		const dataFactoryUrl =
			REACT_APP_DATA_FACTORY_URL && REACT_APP_DATA_FACTORY_URL.toString();
		const showSettings = SETTINGS_PERMISSIONS.some(i =>
			permissions.includes(i)
		);
		const showTaxonomyViewer = permissions.includes(
			PERMISSIONS.TaxonomyReleaseNotes
		);
		const showDataFactoryLink =
			dataFactoryUrl && permissions.includes(PERMISSIONS.DataFactoryAccess);

		return (
			<Subnav
				disabled={this.props.disabled}
				showOnClick
				hideOnChildrenClick
				title="Settings"
				iconName="outline_settings"
				open={subnavOpen}
				activePathnames={[
					'/settings',
					'/settings/archive',
					'/settings/brand',
					'/settings/vendors',
					'/settings/classification',
					'/context',
				]}
				onChangeOpen={this.handleSubnavChangeOpen}
			>
				{!noData &&
					showDataFactoryLink && (
						<SubnavExternalLink
							title="Access To DataFactory"
							href={dataFactoryUrl}
							target="_blank"
						>
							Access To DataFactory
						</SubnavExternalLink>
					)}

				{!noData &&
					showSettings && (
						<SubnavLink to="/demo" onClick={this.handleDemoModeClick}>
							{isDemoMode ? 'Turn demo mode off' : 'Turn demo mode on'}
						</SubnavLink>
					)}

				{(!noData || forceSettings) &&
					showSettings && (
						<SubnavLink
							to="/settings"
							title="Settings"
							onClick={this.handleLinkClick}
						>
							Settings
						</SubnavLink>
					)}

				{!noData &&
					showTaxonomyViewer && (
						<SubnavLink
							to="/taxonomyviewer"
							title="Taxonomy viewer"
							onClick={this.handleLinkClick}
						>
							Taxonomy viewer
						</SubnavLink>
					)}
			</Subnav>
		);
	}

	handleSubnavChangeOpen = open => {
		this.setState({ subnavOpen: open });
	};

	handleLinkClick = () => {
		this.closeSubnav();
	};

	handleDemoModeClick = () => {
		// set demo mode cookie
		setCookie(DEMO_MODE_COOKIE_NAME, !isDemoMode || '');
		// refresh the page
		const { location } = window;
		location.assign(`${location.origin}`);
	};

	closeSubnav = () => {
		this.setState({ subnavOpen: false });
	};
}

export default SettingsSubnav;
